var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3957_4418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3957_4418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20C4.98333 20 3.6875 19.475 2.6125 18.425C1.5375 17.375 1 16.0917 1 14.575C1 13.275 1.39167 12.1167 2.175 11.1C2.95833 10.0833 3.98333 9.43333 5.25 9.15C5.66667 7.61667 6.5 6.375 7.75 5.425C9 4.475 10.4167 4 12 4C13.95 4 15.6042 4.67917 16.9625 6.0375C18.3208 7.39583 19 9.05 19 11C20.15 11.1333 21.1042 11.6292 21.8625 12.4875C22.6208 13.3458 23 14.35 23 15.5C23 16.75 22.5625 17.8125 21.6875 18.6875C20.8125 19.5625 19.75 20 18.5 20H6.5ZM10.35 16.575C10.4833 16.575 10.6083 16.5542 10.725 16.5125C10.8417 16.4708 10.95 16.4 11.05 16.3L15.275 12.075C15.475 11.875 15.575 11.6333 15.575 11.35C15.575 11.0667 15.475 10.825 15.275 10.625C15.075 10.425 14.8333 10.325 14.55 10.325C14.2667 10.325 14.025 10.425 13.825 10.625L10.325 14.125L8.925 12.725C8.74167 12.5417 8.50833 12.45 8.225 12.45C7.94167 12.45 7.70833 12.5417 7.525 12.725C7.325 12.925 7.225 13.1667 7.225 13.45C7.225 13.7333 7.325 13.9667 7.525 14.15L9.65 16.3C9.75 16.4 9.85833 16.4708 9.975 16.5125C10.0917 16.5542 10.2167 16.575 10.35 16.575Z",
    fill: "black",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackup);
export default __webpack_public_path__ + "static/media/backup.8af1824002da6b0f6f3c4215f5846e15.svg";
export { ForwardRef as ReactComponent };